import { render, staticRenderFns } from "./TemperatureViolationsDashboard.vue?vue&type=template&id=7b7f4f0b&scoped=true&"
import script from "./TemperatureViolationsDashboard.vue?vue&type=script&lang=js&"
export * from "./TemperatureViolationsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureViolationsDashboard.vue?vue&type=style&index=0&id=7b7f4f0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7f4f0b",
  null
  
)

export default component.exports